/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonCompanyPosition
 */
export interface JsonCompanyPosition {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonCompanyPosition
     */
    allowedActions?: Array<JsonCompanyPositionAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonCompanyPosition
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPosition
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPosition
     */
    companyPositionId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPosition
     */
    positionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyPosition
     */
    status?: JsonCompanyPositionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyPosition
     */
    title?: string;
}

/**
* @export
* @enum {string}
*/
export enum JsonCompanyPositionAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonCompanyPositionStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonCompanyPositionFromJSON(json: any): JsonCompanyPosition {
    return JsonCompanyPositionFromJSONTyped(json, false);
}

export function JsonCompanyPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonCompanyPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyPositionId': !exists(json, 'companyPositionId') ? undefined : json['companyPositionId'],
        'positionId': !exists(json, 'positionId') ? undefined : json['positionId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function JsonCompanyPositionToJSON(value?: JsonCompanyPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'companyId': value.companyId,
        'companyPositionId': value.companyPositionId,
        'positionId': value.positionId,
        'status': value.status,
        'title': value.title,
    };
}

